import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center py-24" data-testid="payment-cancel-page">
      <div className="text-center max-w-md">
        <XCircle className="w-14 h-14 text-gray-400 mx-auto mb-4" />
        <h1 className="text-xl font-medium">お支払いはキャンセルされました</h1>
        <p className="text-sm text-muted-foreground mt-2">課金は発生していません。いつでも再度お手続きいただけます。</p>
        <Button onClick={() => navigate("/settings/billing")} className="mt-6 bg-brand hover:bg-brand-hover text-white" data-testid="payment-cancel-back">プラン選択へ戻る</Button>
      </div>
    </div>
  );
}
